/* cSpell:disable */
import { HeaderConfig } from '@tenants/types/tenant';
import { RootDomain } from 'constants/domains';
import { LOCALE_EXP_COMMERCIAL_CA_PATHS } from 'types/locales';
export function createHeaderConfig(_rootDomain: RootDomain): HeaderConfig {
  const headerConfig: HeaderConfig = {
    mainButtonCopy: {
      key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_MAINBUTTONCOPY,
      defaultValue: 'Move With Us',
    },
    authButtonCopy: {
      key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_AUTHBUTTONCOPY,
      defaultValue: 'Log in',
    },
    hasJoinExpPage: true,
    hasAdvisorSignIn: false,
    authMenuItems: [
      {
        label: {
          key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_AUTHLINKS_MYSAVEDSEARCHES,
          defaultValue: 'My Saved Searches',
        },
        link: '/account/saved/searches',
        id: 'my-saved-searches',
      },
      {
        label: {
          key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_AUTHLINKS_MYFAVOURITES,
          defaultValue: 'My Favourites',
        },
        link: '/account/saved/favourites',
        id: 'my-favourites',
      },
      {
        label: {
          key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_AUTHLINKS_EDITPROFILE,
          defaultValue: 'Edit Profile',
        },
        link: '/account/details',
        id: 'edit-profile',
      },
      {
        label: {
          key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_AUTHLINKS_SIGNOUT,
          defaultValue: 'Sign Out',
        },
        id: 'sign-out',
        signOut: true,
      },
    ],
    menuItems: [
      {
        id: 'join',
        label: {
          key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_MENULINKS_JOIN,
          defaultValue: 'Join',
        },
        link: '/become-an-advisor',
      },
      // TODO: Add back in the future
      // {
      //   id: 'find-an-expert',
      //   label: {
      //     key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_MENULINKS_FIND_AN_EXPERT,
      //     defaultValue: 'Find an Expert',
      //   },
      //   link: '/experts',
      // },
      {
        id: 'our-services',
        label: {
          key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_MENULINKS_SERVICES,
          defaultValue: 'Services',
        },
        link: '/our-services',
      },
      {
        id: 'insights',
        label: {
          key: LOCALE_EXP_COMMERCIAL_CA_PATHS.HEADER_MENULINKS_INSIGHTS,
          defaultValue: 'Insights',
        },
        link: '/insights',
      },
      {
        id: 'about-us',
        label: {
          key: LOCALE_EXP_COMMERCIAL_CA_PATHS['HEADER_MENULINKS_ABOUT-US'],
          defaultValue: 'About Us',
        },
        link: '/about-us',
      },
    ],
  };

  return headerConfig;
}
